<template>
  <div class="menu-list">
    <div
      class="menu-item index"
      @click="indexClick"
      :class="{'active':$route.fullPath == '/index'}"
    >首页
    </div>
    <div
      class="menu-item"
      :class="{'active':menu.active}"
      v-for="menu in (menuList.length>0?menuList:localMenuList)"
      :key="menu.id"
    >
      <span @click="menuClick(menu)">{{menu.name}}</span>
      <span
        class="close-icon"
        @click="closeMenu(menu)"
      >×</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      localMenuList: [],
    };
  },
  computed: {
    menuList() {
      return this.$store.state[this.$utils.storeKeys.CLICKMENU];
    },
  },
  created() {
    this.localMenuList = this.$utils.getClickMenu();
  },
  methods: {
    closeMenu(menu) {
      let menuList = this.$utils.getClickMenu();
      let menuIndex = menuList.findIndex((item) => {
        return item.id == menu.id;
      });
      let url = "";
      if (menuIndex == 0) {
        if (menuList.length == 1) {
          url = "/index";
        } else {
          menuList[1].active = true;
          url = menuList[1].url;
        }
      } else {
        if(menu.url == this.$route.fullPath){
          for(let i=0;i<menuList.length;i++){
            menuList[i].active = false;
          }
          menuList[menuIndex - 1].active = true;
          url = menuList[menuIndex - 1].url;
        }
      }
      menuList.splice(menuIndex, 1);
      this.$utils.setClickMenu(menuList);
      this.$store.commit(this.$utils.storeKeys.CLICKMENU, menuList);
      if(menu.url == this.$route.fullPath)
         this.$router.push({ path: url });
    },
    menuClick(menu) {
      this.addMenuList(menu);
      this.$router.push({ path: menu.url.trim() });
    },
    indexClick() {
      this.$router.push({ path: "/index" });
    },
    addMenuList(menu) {
      let menuList = this.$utils.getClickMenu();
      menuList.map((item) => {
        item.active = false;
      });
      let currentMenu = menuList.filter((item) => {
        return item.id == menu.id;
      });
      currentMenu[0].active = true;
      this.$utils.setClickMenu(menuList);
      this.$store.commit(this.$utils.storeKeys.CLICKMENU, menuList);
    },
  },
};
</script>
<style>
.menu-list {
  overflow-x: auto;
  background-color: #fff;
  padding: 0 0 10px;
  height: 42px;
  align-items: center;
  margin-bottom: 0px;
  border-bottom: 3px solid #d8d8d8;
  white-space:nowrap;
  overflow-y:hidden;
}
.menu-list .menu-item.index {
  padding-right: 10px;
}
.menu-list .menu-item {
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  border: 1px solid #d8d8d8;
  border-radius: 5px;
  margin-right: 10px;
  padding-right: 30px;
  position: relative;
  cursor: pointer;
  font-size: 13px;
  display: inline-block;
}
.menu-list .menu-item.active {
  background-color: #458cff;
  color: #fff;
}
.menu-list .menu-item .close-icon {
  position: absolute;
  width: 30px;
  height: 30px;
  right: 0px;
  top: 0;
  text-align: center;
  line-height: 30px;
  font-size: 13px;
}
</style>


// WEBPACK FOOTER //
// src/components/business/menuList.vue